import { isStatedItem } from 'swag-common/utils/order';
export function isOrderItemRejected(item) {
  return !isStatedItem(item);
}